export function padZero(n: number): string {
  return n.toString().padStart(2, '0')
}

export function formatNumber(n: number): string {
  return n.toLocaleString('en-US')
}

export function formatCurrency(n: number, decimals?: number): string {
  if (decimals != null) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
  }
  return '$' + n.toLocaleString('en-US')
}

/**
 * Format a cap/usage value in its offer's unit: dollars for USD offers,
 * a plain conversion count for conversion-denominated offers.
 */
export function formatCap(n: number, capUnit: 'usd' | 'conversions' = 'usd'): string {
  if (capUnit === 'conversions') {
    const v = Math.round(n)
    return `${v.toLocaleString('en-US')} cv${v === 1 ? '' : 's'}`
  }
  return formatCurrency(n)
}

export function formatPercentage(used: number, total: number): string {
  if (total === 0) return '0%'
  const pct = Math.min(100, (used / total) * 100)
  return `${pct.toFixed(1)}%`
}

export function getPercentage(used: number, total: number): number {
  if (total === 0) return 0
  return Math.min(100, (used / total) * 100)
}

export function formatEta(remainingDollars: number, ratePerHour: number): string {
  if (ratePerHour <= 0 || remainingDollars <= 0) return '—'
  const hours = remainingDollars / ratePerHour
  if (hours < 1) return '< 1h'
  if (hours < 24) return `~${Math.round(hours)}h`
  const days = Math.floor(hours / 24)
  const remHours = Math.round(hours % 24)
  if (days === 1) return `~1d ${remHours}h`
  return `~${days}d ${remHours}h`
}
